import { apiClient } from "../apiClient";
import type {
  SupportConfig,
  UpdateSupportParams,
  ApiResponse,
} from "./supportClient.dto";

/**
 * Support Configuration API Client
 *
 * Provides methods for managing custom support and helpdesk configuration
 * for organizations.
 * Uses DTOs from supportClient.dto.ts for type safety.
 */
const supportClient = {
  /**
   * Get support configuration for an organization
   * @param orgId - Organization ID (optional)
   * @returns Support configuration
   */
  get(orgId?: number): ApiResponse<SupportConfig> {
    return apiClient.get(`/rest/customSupport?orgId=${orgId ? orgId : ""}`);
  },

  /**
   * Update support configuration for an organization
   * @param orgId - Organization ID (optional)
   * @param params - Support configuration parameters
   * @returns Updated support configuration
   */
  update(orgId: number | undefined, params: UpdateSupportParams): ApiResponse<SupportConfig> {
    return apiClient.put(
      `/rest/customSupport?orgId=${orgId ? orgId : ""}`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },
};

export default supportClient;
